import { formPost, get, put, post } from './restAPI';
import axios from 'axios';
import { format } from 'date-fns';

const request = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    // baseURL: 'https://10.107.4.227:8080/scLoan',
    // baseURL: 'http://10.107.6.140:8080/scLoan',
});
/** -------------------------- 會員 -------------------------- */
/** 會員登入 [POST]
 */
export const callLoginUser = postData =>
    request.post('/SCLOAN090/login', postData);
export const callLoginTest = postData =>
    request.post('/SCLOAN090/login', {
        bid: '2',
        idno: 'A234567891',
        loginAccount: 'money',
    });
/** callGetCustomerInfo客戶收合資訊 [POST]
 */
export const callGetCustomerInfo = () => post('/SCLOAN090/customerInfo', {});

/** ---------------------------借款申請 -------------------------   */
/** callFindCustomerStockList 客戶股票庫存[POST]
 */
export const callFindCustomerStockList = () =>
    post('/SCLOAN010/findCustomerStockList', {});

/** callLendApply 客戶借款申請[POST]
 */
export const callLendApply = postData => post('/SCLOAN010/lendApply', postData);

/** customerLendInfo  客戶借款資訊 [POST]
 */
export const callCustomerLendApply = () =>
    post('/SCLOAN010/customerLendInfo', {});

/** callSetCollateralList 設定擔保品[Post]
 */
export const callSetCollateralList = postData =>
    post('/SCLOAN010/setCollateralList', postData);

/** callFindCustomerCollateralList 客戶擔保品庫存查詢[POST]
 */
export const callFindCollateralList = () =>
    post('/SCLOAN030/findCustomerCollateralList', {});

/** getFindIsBusinessTime 借款營業時間查詢[GET]
 */
export const getFindBusinessTime = params =>
    get(`/SCLOAN010/findLendBusinessTime`, params);
/** ---------------------------還款申請 -------------------------  */
/* repayMentCashQry 現金還款查詢 [POST]
 */
// export const callRepayMentCashQry = () =>
//     post('/SCLOAN020/repayMentCashQry', {
//         month: format(new Date(), 'MM'),
//         year: format(new Date(), 'yyyy'),
//     });
export const callRepayMentCashQry = postData =>
    post('/SCLOAN020/repayMentCashQry', postData);

/* findCustomerCollateralList 客戶可抵押股票庫存查詢 [POST] 就是賣股還款查詢 [GET]
 */
export const callRayMentStockQry = () =>
    post('/SCLOAN030/findCustomerCollateralList', {});

/* addRayMentDetail 現金還款申請 [POST] 和 賣股還款申請 [POST] 暫時用同一個
 */
export const callApplyRepayment = postData =>
    post('/SCLOAN020/addRayMentDetail', postData);

/** -------------------------退還擔保品--------------------------   */

/** callFindCustomerCollateralList 客戶擔保品庫存查詢[POST]
 */
export const callFindCustomerCollateralList = () =>
    post('/SCLOAN030/findCustomerCollateralList', {});

/** callReturnCollateralApply 申請退還擔保品[POST]
 */
export const callReturnCollateralApply = postData =>
    post('/SCLOAN030/returnCollateralApply', postData);
/** -------------------------帳務查詢--------------------------   */

/** getQryAccountInfo 帳戶資訊[GET]
 */

export const getQryAccountInfo = params =>
    get(`/SCLOAN040/qryAccountInfo`, params);

/** getQryLendDetail 借款查詢[POST]
 */
export const getQryLendDetail = postData =>
    post('/SCLOAN040/qryLendDetail', postData);

/** getQryRepaymentDetails 還款查詢[POST]
 */
export const getQryRepaymentDetails = postData =>
    post('/SCLOAN040/qryRayMentDetails', postData);

/** getQryCollateral 擔保品彙總查詢[GET]
 */
export const getQryCollateral = params =>
    get('/SCLOAN040/qryCollateral', params);

/** getQryBankStatement 對帳單查詢[POST]
 */
export const getQryBankStatement = postData =>
    post('/SCLOAN040/qryBankStatement', postData);

/* updateRepayment 取消還款[POST] */
export const cancelRepayment = postData =>
    post('/SCLOAN040/repaymentCancel', postData);

/** -------------------------借款維持率試算--------------------------   */
/* qryCollateralCal 擔保品查詢 [POST]
 */
export const callQryCollateralCal = () =>
    post('/SCLOAN050/qryCollateralCal', {});

/* editCollateral 異動擔保品 [POST]
 */
export const callEditCollateral = postData =>
    post('/SCLOAN050/editCollateral', postData);

export const callUserBasicInfo = data =>
    post('http://10.107.6.140:8080/SCLOAN090/customerInfo', data);

export const callUserStockInfo = data =>
    post('http://10.107.6.140:8080/SCLOAN030/findCustomerCollateralList', data);
/**
 * 借款額度查詢
 */
export const getSwitchLoanOption = params => {
    get(`/SCLOAN010/switchLoanOptionQueryTest`, params);
};
// 驗章
export const verifySign = postData => post('/SCLOAN010/verifySign', postData);
